import { Provider } from '@angular/core';
import { GetListHandoverTakeoverUseCase } from '@app/application/use-cases/handover-takeover/get-list-handover-takeover.use-case';
import { HandoverTakeoverRepository } from '@app/domain/repositories/handover-takeover.repository';
import { HandoverTakeoverRepositoryImpl } from '../repositories/handover-takeover.repository.impl';

export const HANDOVER_TAKEOVER_PROVIDERS: Provider[] = [
  {
    provide: HandoverTakeoverRepository,
    useClass: HandoverTakeoverRepositoryImpl,
  },
  {
    provide: GetListHandoverTakeoverUseCase,
    useFactory: (repo: HandoverTakeoverRepository) =>
      new GetListHandoverTakeoverUseCase(repo),
    deps: [HandoverTakeoverRepository],
  },
];